/**
 * this is the Whitebox company theme color
 * do NOT use this color directly
 * instead, select the value from the state
 */
export const mainColor = '#27a4a1';
